/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: stylings.ts
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/

/**************************************************************************************************************************
 TYPES / GLOBAL DEFINITIONS
***************************************************************************************************************************/
const Input: Record<string, string> =  {
    label: 'text-md text-themeDarkBlue-900 font-aldrich font-semibold',
    input: 'text-md text-black font-inter font-light placeholder:font-urbanist'
};

const RadioGroup: Record<string, string> = {
    label: 'text-sm text-theme-900 font-inter font-semibold'
};

const Radio: Record<string, string> = {
    label: 'text-md font-inter font-light'
};

const Checkbox: Record<string, string> = {
    label: 'text-md font-inter font-light'
};

const Stylings = {
  Checkbox,
  Input,
  RadioGroup,
  Radio
};

export default Stylings;